import { useLayoutEffect, useRef } from 'react';
import { useCanvas, useFlowContext } from '@/components/Recipe/FlowContext';
import type { NodeId } from 'web';

interface EngineCanvasSurfaceProps {
  nodeId: NodeId;
  className?: string;
}

/**
 * Presents the one shared engine WebGL canvas directly in an exclusive UI surface.
 */
export function EngineCanvasSurface({ nodeId, className }: EngineCanvasSurfaceProps) {
  const { graph } = useFlowContext();
  const { setParent, unsetParent } = useCanvas();
  const containerRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const container = containerRef.current;
    if (!container) {
      return;
    }

    setParent(container);
    graph.wasm.call((wasm) => {
      wasm.enableNodeEditor(nodeId);
    });

    return () => {
      graph.wasm.call((wasm) => {
        wasm.disableNodeEditor();
      });
      unsetParent(container);
    };
  }, [graph, nodeId, setParent, unsetParent]);

  return (
    <div
      ref={containerRef}
      className={className}
      style={{ position: 'relative', width: '100%', height: '100%', overflow: 'hidden' }}
    />
  );
}
